module.exports = __webpack_public_path__ + "img/Ktirio-More-2.695cee83.jpg";